// Header scrolling class
if (document.querySelector("header")) {
    const header = document.querySelector("header");

    function checkScroll() {
        let scrollTop = window.scrollY;

        if (scrollTop > 20) {
            header.classList.add("header-scrolling");
        } else {
            header.classList.remove("header-scrolling");
        }
    }

    checkScroll();
    window.addEventListener("scroll", checkScroll);
}


// Back To Top scrolling class
if (document.querySelector("#backToTop")) {
    const backToTopBtn = document.querySelector("#backToTop");

    function checkScroll() {
        let scrollTop = window.scrollY;

        if (scrollTop > 400) {
            backToTopBtn.classList.add("backToTop-scrolling");
            backToTopBtn.removeAttribute('tabindex');
        } else {
            backToTopBtn.classList.remove("backToTop-scrolling");
            backToTopBtn.setAttribute('tabindex', '-1');
        }
    }

    checkScroll();
    window.addEventListener("scroll", checkScroll);
}